import React, { Component, PureComponent } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { endsWith, isEmpty, isNumber, isFunction } from 'lodash';
import { isPaywallSeo, getPaywallSeoClass } from './utils/paywallSeo.js';
import { BLOCK_TYPES, getTextDirection, DOC_STYLE_TYPES, getDirectionFromAlignmentAndTextDirection, depthClassName, IMAGE_TYPE, GALLERY_TYPE, VIDEO_TYPE, normalizeInitialState, mergeStyles, Version, createJustificationFixDecorator, SPOILER_TYPE, GlobalContext, getLangDir, AccessibilityListener, normalizeHref, getRelValue, HTML_TYPE, MAP_TYPE, ACTION_BUTTON_TYPE, LINK_BUTTON_TYPE, alignmentClassName, sizeClassName, textWrapClassName, TABLE_TYPE } from 'wix-rich-content-common';
import { getBlockIndex } from './utils/draftUtils.js';
import require$$0 from 'punycode';
import { L as List, v as viewerStyles } from './List-c8266bae.js';
import { withInteraction } from './withInteraction.js';
import Anchor from './components/Anchor.js';
import { ErrorBoundary } from './components/ErrorBoundary.js';
import { kebabToCamelObjectKeys, hasText } from './utils/textUtils.js';
import { getViewerInlineStyleMappers } from './inlineStyleMapper.js';
import { combineMappers } from './utils/combineMappers.js';
import { deprecateHelpers } from 'wix-rich-content-common/libs/deprecateHelpers';

var draftDefaultStyles = {"renderedInTable":"cv0sq"};

function getDefaultExportFromCjs (x) {
	return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, 'default') ? x['default'] : x;
}

var lib = {};

var RawParser = {};

var ContentNode = {};

var arrayEqual = {};

(function (exports) {

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;

	/**
	 * Very simple array comparison
	 */
	var arraysEqual = function arraysEqual(arr1, arr2) {
	  if (arr1.length !== arr2.length) {
	    return false;
	  } // defining for loops with airbnb config is a pain maybe should disable some rules
	  // eslint-disable-next-line


	  for (var i = 0; i < arr1.length; i++) {
	    if (arr1[i] !== arr2[i]) {
	      return false;
	    }
	  }

	  return true;
	};

	var _default = arraysEqual;
	exports["default"] = _default;
} (arrayEqual));

(function (exports) {

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;

	var _arrayEqual = _interopRequireDefault(arrayEqual);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

	function _toArray(arr) { return _arrayWithHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableRest(); }

	function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

	function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

	function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

	function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

	function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

	function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter); }

	function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

	function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

	var ContentNode = /*#__PURE__*/function () {
	  function ContentNode(props) {
	    _classCallCheck(this, ContentNode);

	    this.content = props.content || [];
	    this.start = typeof props.start !== 'undefined' ? props.start : null;
	    this.end = typeof props.end !== 'undefined' ? props.end : null;
	    this.entity = typeof props.entity !== 'undefined' ? props.entity : null;
	    this.decorator = typeof props.decorator !== 'undefined' ? props.decorator : null;
	    this.decoratorProps = props.decoratorProps || null;
	    this.decoratedText = typeof props.decoratedText !== 'undefined' ? props.decoratedText : null;
	    this.contentState = props.contentState;
	    this.style = props.style || null;
	    this.styles = props.styles || null;
	    this.block = props.block || {};
	  }

	  _createClass(ContentNode, [{
	    key: "getCurrentContent",
	    value: function getCurrentContent() {
	      return this.content[this.content.length - 1];
	    }
	  }, {
	    key: "addToCurrentContent",
	    value: function addToCurrentContent(string) {
	      this.content[this.content.length - 1] = this.content[this.content.length - 1] + string;
	    }
	  }, {
	    key: "handleFlatPush",
	    value: function handleFlatPush(string, stack) {
	      var current = this.getCurrentContent(); // if the stacks are equal just add the string to the current node

	      if (current instanceof ContentNode && (0, _arrayEqual["default"])(stack, current.styles)) {
	        current.addToCurrentContent(string);
	        return;
	      } // create a node with whole styles stack


	      var newNode = new ContentNode({
	        styles: _toConsumableArray(stack),
	        content: [string]
	      });
	      this.content.push(newNode);
	    }
	  }, {
	    key: "pushContent",
	    value: function pushContent(string) {
	      var stack = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
	      var flat = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

	      // we can just concat strings when both the pushed item
	      // and the last element of the content array is a string
	      if (!stack || stack.length < 1) {
	        if (typeof string === 'string' && typeof this.getCurrentContent() === 'string') {
	          this.addToCurrentContent(string);
	        } else {
	          this.content.push(string);
	        }

	        return this;
	      } // handle flat structure


	      if (flat) {
	        this.handleFlatPush(string, stack);
	        return this;
	      }

	      var _stack = _toArray(stack),
	          head = _stack[0],
	          rest = _stack.slice(1);

	      var current = this.getCurrentContent();

	      if (current instanceof ContentNode && current.style === head) {
	        current.pushContent(string, rest, flat);
	      } else {
	        var newNode = new ContentNode({
	          style: head
	        });
	        newNode.pushContent(string, rest, flat);
	        this.content.push(newNode);
	      }

	      return this;
	    }
	  }]);

	  return ContentNode;
	}();

	var _default = ContentNode;
	exports["default"] = _default;
} (ContentNode));

(function (exports) {

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;

	var _punycode = _interopRequireDefault(require$$0);

	var _ContentNode = _interopRequireDefault(ContentNode);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

	function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

	function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

	function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

	function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter); }

	function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

	function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

	/**
	 * Slices the decoded ucs2 array and encodes the result back to a string representation
	 */
	var getString = function getString(array, from, to) {
	  return _punycode["default"].ucs2.encode(array.slice(from, to));
	};
	/**
	 * creates nodes with entity keys and the endOffset
	 */


	function createNodes(entityRanges) {
	  var decoratorRanges = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
	  var textArray = arguments.length > 2 ? arguments[2] : undefined;
	  var block = arguments.length > 3 ? arguments[3] : undefined;
	  var lastIndex = 0;
	  var mergedRanges = [].concat(_toConsumableArray(entityRanges), _toConsumableArray(decoratorRanges)).sort(function (a, b) {
	    return a.offset - b.offset;
	  });
	  var nodes = []; // if thers no entities will return just a single item

	  if (mergedRanges.length < 1) {
	    nodes.push(new _ContentNode["default"]({
	      block: block,
	      start: 0,
	      end: textArray.length
	    }));
	    return nodes;
	  }

	  mergedRanges.forEach(function (range) {
	    // create an empty node for content between previous and this entity
	    if (range.offset > lastIndex) {
	      nodes.push(new _ContentNode["default"]({
	        block: block,
	        start: lastIndex,
	        end: range.offset
	      }));
	    } // push the node for the entity


	    nodes.push(new _ContentNode["default"]({
	      block: block,
	      entity: range.key,
	      decorator: range.component,
	      decoratorProps: range.decoratorProps,
	      decoratedText: range.component ? getString(textArray, range.offset, range.offset + range.length) : undefined,
	      start: range.offset,
	      end: range.offset + range.length,
	      contentState: range.contentState
	    }));
	    lastIndex = range.offset + range.length;
	  }); // finaly add a node for the remaining text if any

	  if (lastIndex < textArray.length) {
	    nodes.push(new _ContentNode["default"]({
	      block: block,
	      start: lastIndex,
	      end: textArray.length
	    }));
	  }

	  return nodes;
	}

	function addIndexes(indexes, ranges) {
	  ranges.forEach(function (range) {
	    indexes.push(range.offset);
	    indexes.push(range.offset + range.length);
	  });
	  return indexes;
	}
	/**
	 * Creates an array of sorted char indexes to avoid iterating over every single character
	 */


	function getRelevantIndexes(text, inlineRanges) {
	  var entityRanges = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
	  var decoratorRanges = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : [];
	  var relevantIndexes = []; // set indexes to corresponding keys to ensure uniquenes

	  relevantIndexes = addIndexes(relevantIndexes, inlineRanges);
	  relevantIndexes = addIndexes(relevantIndexes, entityRanges);
	  relevantIndexes = addIndexes(relevantIndexes, decoratorRanges); // add text start and end to relevant indexes

	  relevantIndexes.push(0);
	  relevantIndexes.push(text.length);
	  var uniqueRelevantIndexes = relevantIndexes.filter(function (value, index, self) {
	    return self.indexOf(value) === index;
	  }); // and sort it

	  return uniqueRelevantIndexes.sort(function (aa, bb) {
	    return aa - bb;
	  });
	}

	var RawParser = /*#__PURE__*/function () {
	  function RawParser(_ref) {
	    var _ref$flat = _ref.flat,
	        flat = _ref$flat === void 0 ? false : _ref$flat;

	    _classCallCheck(this, RawParser);

	    this.flat = flat;
	  }

	  _createClass(RawParser, [{
	    key: "relevantStyles",
	    value: function relevantStyles(offset) {
	      var styles = this.ranges.filter(function (range) {
	        return offset >= range.offset && offset < range.offset + range.length;
	      });
	      return styles.map(function (style) {
	        return style.style;
	      });
	    }
	    /**
	     * Loops over relevant text indexes
	     */

	  }, {
	    key: "nodeIterator",
	    value: function nodeIterator(node, start, end) {
	      var _this = this;

	      var indexes = this.relevantIndexes.slice(this.relevantIndexes.indexOf(start), this.relevantIndexes.indexOf(end)); // loops while next index is smaller than the endOffset

	      indexes.forEach(function (index, key) {
	        // figure out what styles this char and the next char need
	        // (regardless of whether there *is* a next char or not)
	        var characterStyles = _this.relevantStyles(index); // calculate distance or set it to 1 if thers no next index


	        var distance = indexes[key + 1] ? indexes[key + 1] - index : 1; // add all the chars up to next relevantIndex

	        var text = getString(_this.textArray, index, index + distance);
	        node.pushContent(text, characterStyles, _this.flat); // if thers no next index and thers more text left to push

	        if (!indexes[key + 1] && index < end) {
	          node.pushContent(getString(_this.textArray, index + 1, end), _this.relevantStyles(end - 1), _this.flat);
	        }
	      });
	      return node;
	    }
	    /**
	     * Converts raw block to object with nested style objects,
	     * while it returns an object not a string
	     * the idea is still mostly same as backdraft.js (https://github.com/evanc/backdraft-js)
	     */

	  }, {
	    key: "parse",
	    value: function parse(block) {
	      var _this2 = this;

	      var text = block.text,
	          ranges = block.inlineStyleRanges,
	          entityRanges = block.entityRanges,
	          _block$decoratorRange = block.decoratorRanges,
	          decoratorRanges = _block$decoratorRange === void 0 ? [] : _block$decoratorRange; // Some unicode charactes actualy have length of more than 1
	      // this creates an array of code points using es6 string iterator

	      this.textArray = _punycode["default"].ucs2.decode(text);
	      this.ranges = ranges;
	      this.iterator = 0; // get all the relevant indexes for whole block

	      this.relevantIndexes = getRelevantIndexes(text, ranges, entityRanges, decoratorRanges); // create entity or empty nodes to place the inline styles in

	      var nodes = createNodes(entityRanges, decoratorRanges, this.textArray, block);
	      var parsedNodes = nodes.map(function (node) {
	        return _this2.nodeIterator(node, node.start, node.end);
	      });
	      return new _ContentNode["default"]({
	        block: block,
	        content: parsedNodes
	      });
	    }
	  }]);

	  return RawParser;
	}();

	exports["default"] = RawParser;
} (RawParser));

var createStyleRenderer = {};

(function (exports) {

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;

	/**
	 * Returns a single style object provided styleArray and stylesMap
	 */
	var reduceStyles = function reduceStyles(styleArray, stylesMap) {
	  return styleArray.map(function (style) {
	    return stylesMap[style];
	  }).reduce(function (prev, next) {
	    var mergedStyles = {};

	    if (next !== undefined) {
	      var key = 'text-decoration' in next ? 'text-decoration' : 'textDecoration';

	      if (next[key] !== prev[key]) {
	        // .trim() is necessary for IE9/10/11 and Edge
	        mergedStyles[key] = [prev[key], next[key]].join(' ').trim();
	      }
	    }

	    return Object.assign(prev, next, mergedStyles);
	  }, {});
	};
	/**
	 * Returns a styleRenderer from a customStyleMap and a wrapper callback (Component)
	 */


	var createStyleRenderer = function createStyleRenderer(wrapper, stylesMap) {
	  return function (children, styleArray, params) {
	    var style = reduceStyles(styleArray, stylesMap);
	    return wrapper(Object.assign({}, {
	      children: children
	    }, params, {
	      style: style
	    }));
	  };
	};

	var _default = createStyleRenderer;
	exports["default"] = _default;
} (createStyleRenderer));

var createBlockRenderer = {};

(function (exports) {

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;

	function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

	function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

	function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

	function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter); }

	function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

	function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

	var KEY_DELIMITER = ','; // Return either a single key if present or joined keys array from props;

	var getKey = function getKey(_ref, key) {
	  var keys = _ref.keys;

	  if (key) {
	    return key;
	  }

	  if (!keys) {
	    return undefined;
	  }

	  return keys.join(KEY_DELIMITER);
	}; // Call the wrapper with element, props, and spread children
	// this order is specific to React.createElement


	var getBlock = function getBlock(element, wrapper, withDepth) {
	  return function (children, properties, key) {
	    var props = Object.assign({}, properties);

	    if (!withDepth) {
	      delete props.depth;
	    }

	    return wrapper.apply(void 0, [element, Object.assign({}, props, {
	      key: getKey(props, key)
	    })].concat(_toConsumableArray(children)));
	  };
	}; // Handle blocks with wrapper element defined


	var getWrappedChildren = function getWrappedChildren(callback, block, _ref2) {
	  var children = _ref2.children,
	      props = _ref2.props,
	      key = _ref2.key;
	  var wrapperBlockFn = getBlock(block.wrapper, callback);
	  var blockFn = getBlock(block.element, callback, true);
	  return wrapperBlockFn(children.map(function (child, ii) {
	    return blockFn(child, {}, props.keys && props.keys[ii]);
	  }), props, key);
	};
	/**
	* Returns a blockRenderer crated from a blockRendererMap using a callback ie. React.createElement
	*/


	var createBlockRenderer = function createBlockRenderer(callback, blockMap) {
	  var renderer = {};
	  Object.keys(blockMap).forEach(function (item) {
	    var block = blockMap[item]; // If wrapper is present children need to be nested inside

	    if (block.wrapper) {
	      renderer[item] = function (children, props, key) {
	        return getWrappedChildren(callback, block, {
	          children: children,
	          props: props,
	          key: key
	        });
	      };

	      return;
	    } // Wrapper is not present


	    renderer[item] = getBlock(block.element, callback);
	  });
	  return renderer;
	};

	var _default = createBlockRenderer;
	exports["default"] = _default;
} (createBlockRenderer));

var render$1 = {};

var warn = {};

(function (exports) {

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;

	/**
	 * Logs a warning message if not in production
	 */
	var warn = function warn(msg) {
	};

	var _default = warn;
	exports["default"] = _default;
} (warn));

var checkCleanup = {};

(function (exports) {

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;

	/**
	 * Check if block has any text, respects trim setting
	 */
	var hasText = function hasText(text, _ref) {
	  var trim = _ref.trim;
	  return !!(trim ? text.trim() : text);
	};
	/**
	 * Check if block has any data like text, metadata or entities
	 */


	var hasData = function hasData(block, options) {
	  if (hasText(block.text, options)) {
	    return true;
	  }

	  if (block.data && Object.keys(block.data).length) {
	    return true;
	  }

	  if (block.entityRanges && block.entityRanges.length) {
	    return true;
	  }

	  return false;
	};
	/**
	 * Checks if current block is empty and if it should be ommited according to passed settings
	 */


	var checkCleanup = function checkCleanup(block, prevType, _ref2) {
	  var cleanup = _ref2.cleanup;

	  if (!cleanup || hasData(block, cleanup)) {
	    return false;
	  } // Check if cleanup is enabled after prev type


	  if (cleanup.after && cleanup.after !== 'all' && !cleanup.after.includes(prevType)) {
	    return false;
	  } // Handle the except array if passed


	  if (cleanup.except && !cleanup.except.includes(block.type)) {
	    return true;
	  } // Finaly if cleanup is enabled for current type


	  if (cleanup.types && (cleanup.types === 'all' || cleanup.types.includes(block.type))) {
	    return true;
	  }

	  return false;
	};

	var _default = checkCleanup;
	exports["default"] = _default;
} (checkCleanup));

var getKeyGenerator = {};

(function (exports) {

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;

	// return a new generator wich produces sequential keys for nodes
	var getKeyGenerator = function getKeyGenerator() {
	  var key = 0;

	  var keyGenerator = function keyGenerator() {
	    var current = key;
	    key += 1;
	    return current; // eslint-disable-line no-plusplus
	  };

	  return keyGenerator;
	};

	var _default = getKeyGenerator;
	exports["default"] = _default;
} (getKeyGenerator));

var checkJoin = {};

(function (exports) {

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;

	/**
	 * Joins the input if the joinOutput option is enabled
	 */
	var checkJoin = function checkJoin(input, options) {
	  if (Array.isArray(input) && options.joinOutput) {
	    return input.join('');
	  }

	  return input;
	};

	var _default = checkJoin;
	exports["default"] = _default;
} (checkJoin));

var pushString = {};

(function (exports) {

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;

	/**
	 * Concats or insets a string at given array index
	 */
	var pushString = function pushString(string, array, index) {
	  var tempArray = array;

	  if (!array[index]) {
	    tempArray[index] = string;
	  } else {
	    tempArray[index] += string;
	  }

	  return tempArray;
	};

	var _default = pushString;
	exports["default"] = _default;
} (pushString));

var defaultOptions = {};

(function (exports) {

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	var defaultOptions = {
	  joinOutput: false,
	  cleanup: {
	    after: ['atomic'],
	    types: ['unstyled'],
	    trim: false,
	    split: true
	  }
	};
	var _default = defaultOptions;
	exports["default"] = _default;
} (defaultOptions));

var withDecorators = {};

var CompositeDecorator = {};

(function (exports) {

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

	/**
	 * This is only slighly modified version of draft-js CompositeDraftDecorator
	 * https://github.com/facebook/draft-js/blob/dc27624caaaede4dad9d182ff9918a5da8f83c99/src/model/decorators/CompositeDraftDecorator.js
	 *
	 * Basicly it just swaps the Immutable.js List with own ListStub
	 *
	 * 
	 */
	// eslint-disable-next-line import/no-extraneous-dependencies
	// eslint-disable-next-line import/no-extraneous-dependencies
	// eslint-disable-next-line import/no-extraneous-dependencies
	var DELIMITER = '.';
	/**
	 * Determine whether we can occupy the specified slice of the decorations
	 * array.
	 */

	function canOccupySlice(decorations, start, end) {
	  // eslint-disable-next-line no-plusplus
	  for (var ii = start; ii < end; ii++) {
	    if (decorations[ii] != null) {
	      return false;
	    }
	  }

	  return true;
	}
	/**
	 * Splice the specified component into our decoration array at the desired
	 * range.
	 */


	function occupySlice(targetArr, start, end, componentKey) {
	  // eslint-disable-next-line no-plusplus
	  for (var ii = start; ii < end; ii++) {
	    // eslint-disable-next-line no-param-reassign
	    targetArr[ii] = componentKey;
	  }
	}
	/**
	 * A CompositeDraftDecorator traverses through a list of DraftDecorator
	 * instances to identify sections of a ContentBlock that should be rendered
	 * in a "decorated" manner. For example, hashtags, mentions, and links may
	 * be intended to stand out visually, be rendered as anchors, etc.
	 *
	 * The list of decorators supplied to the constructor will be used in the
	 * order they are provided. This allows the caller to specify a priority for
	 * string matching, in case of match collisions among decorators.
	 *
	 * For instance, I may have a link with a `#` in its text. Though this section
	 * of text may match our hashtag decorator, it should not be treated as a
	 * hashtag. I should therefore list my link DraftDecorator
	 * before my hashtag DraftDecorator when constructing this composite
	 * decorator instance.
	 *
	 * Thus, when a collision like this is encountered, the earlier match is
	 * preserved and the new match is discarded.
	 */


	var CompositeDraftDecorator = /*#__PURE__*/function () {
	  function CompositeDraftDecorator(decorators) {
	    _classCallCheck(this, CompositeDraftDecorator);

	    _defineProperty(this, "decorators", void 0);

	    // Copy the decorator array, since we use this array order to determine
	    // precedence of decoration matching. If the array is mutated externally,
	    // we don't want to be affected here.
	    this.decorators = decorators.slice();
	  }

	  _createClass(CompositeDraftDecorator, [{
	    key: "getDecorations",
	    value: function getDecorations(block, contentState) {
	      var decorations = Array(block.getText().length).fill(null);
	      this.decorators.forEach(function (
	      /* object*/
	      decorator,
	      /* number*/
	      ii) {
	        var counter = 0;
	        var strategy = decorator.strategy;

	        var callback = function callback(
	        /* number*/
	        start,
	        /* number*/
	        end) {
	          // Find out if any of our matching range is already occupied
	          // by another decorator. If so, discard the match. Otherwise, store
	          // the component key for rendering.
	          if (canOccupySlice(decorations, start, end)) {
	            occupySlice(decorations, start, end, ii + DELIMITER + counter); // eslint-disable-next-line no-plusplus

	            counter++;
	          }
	        };

	        strategy(block, callback, contentState);
	      });
	      return decorations;
	    }
	  }, {
	    key: "getComponentForKey",
	    value: function getComponentForKey(key) {
	      var componentKey = parseInt(key.split(DELIMITER)[0], 10);
	      return this.decorators[componentKey].component;
	    }
	  }, {
	    key: "getPropsForKey",
	    value: function getPropsForKey(key) {
	      var componentKey = parseInt(key.split(DELIMITER)[0], 10);
	      return this.decorators[componentKey].props;
	    }
	  }]);

	  return CompositeDraftDecorator;
	}();

	var _default = CompositeDraftDecorator;
	exports["default"] = _default;
} (CompositeDecorator));

var MultiDecorator = {};

(function (exports) {

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

	var KEY_SEPARATOR = '-';

	var MultiDecorator = /*#__PURE__*/function () {
	  function MultiDecorator(decorators) {
	    _classCallCheck(this, MultiDecorator);

	    this.decorators = decorators;
	  }
	  /**
	   * Return list of decoration IDs per character
	   *
	   * @param {ContentBlock} block
	   * @return {List<String>}
	   */


	  _createClass(MultiDecorator, [{
	    key: "getDecorations",
	    value: function getDecorations(block, contentState) {
	      var decorations = new Array(block.getText().length).fill(null);
	      this.decorators.forEach(function (decorator, i) {
	        var subDecorations = decorator.getDecorations(block, contentState);
	        subDecorations.forEach(function (key, offset) {
	          if (!key) {
	            return;
	          }

	          decorations[offset] = i + KEY_SEPARATOR + key;
	        });
	      });
	      return decorations;
	    }
	    /**
	     * Return component to render a decoration
	     *
	     * @param {String} key
	     * @return {Function}
	     */

	  }, {
	    key: "getComponentForKey",
	    value: function getComponentForKey(key) {
	      var decorator = this.getDecoratorForKey(key);
	      return decorator.getComponentForKey(MultiDecorator.getInnerKey(key));
	    }
	    /**
	     * Return props to render a decoration
	     *
	     * @param {String} key
	     * @return {Object}
	     */

	  }, {
	    key: "getPropsForKey",
	    value: function getPropsForKey(key) {
	      var decorator = this.getDecoratorForKey(key);
	      return decorator.getPropsForKey(MultiDecorator.getInnerKey(key));
	    }
	    /**
	     * Return a decorator for a specific key
	     *
	     * @param {String} key
	     * @return {Decorator}
	     */

	  }, {
	    key: "getDecoratorForKey",
	    value: function getDecoratorForKey(key) {
	      var parts = key.split(KEY_SEPARATOR);
	      var index = Number(parts[0]);
	      return this.decorators[index];
	    }
	    /**
	     * Return inner key for a decorator
	     *
	     * @param {String} key
	     * @return {String}
	     */

	  }], [{
	    key: "getInnerKey",
	    value: function getInnerKey(key) {
	      var parts = key.split(KEY_SEPARATOR);
	      return parts.slice(1).join(KEY_SEPARATOR);
	    }
	  }]);

	  return MultiDecorator;
	}();

	var _default = MultiDecorator;
	exports["default"] = _default;
} (MultiDecorator));

var stubContentBlock = {};

(function (exports) {

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

	/**
	 * This is a simple replacement for draft-js ContentBlock,
	 * CharacterList or any related methods are not implented here
	 */
	var ContentBlockStub = /*#__PURE__*/function () {
	  function ContentBlockStub(block) {
	    _classCallCheck(this, ContentBlockStub);

	    Object.assign(this, block);
	  }

	  _createClass(ContentBlockStub, [{
	    key: "get",
	    value: function get(name) {
	      return this[name];
	    }
	  }, {
	    key: "getText",
	    value: function getText() {
	      return this.text;
	    }
	  }, {
	    key: "getType",
	    value: function getType() {
	      return this.type;
	    }
	  }, {
	    key: "getKey",
	    value: function getKey() {
	      return this.key;
	    }
	  }, {
	    key: "getLength",
	    value: function getLength() {
	      return this.text.length;
	    }
	  }, {
	    key: "getDepth",
	    value: function getDepth() {
	      return this.depth;
	    }
	  }, {
	    key: "getData",
	    value: function getData() {
	      return this.data;
	    }
	  }]);

	  return ContentBlockStub;
	}();

	var stubContentBlock = function stubContentBlock(block) {
	  return new ContentBlockStub(block);
	};

	var _default = stubContentBlock;
	exports["default"] = _default;
} (stubContentBlock));

(function (exports) {

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;

	var _punycode = _interopRequireDefault(require$$0);

	var _CompositeDecorator = _interopRequireDefault(CompositeDecorator);

	var _MultiDecorator = _interopRequireDefault(MultiDecorator);

	var _stubContentBlock = _interopRequireDefault(stubContentBlock);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

	function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

	function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

	function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

	function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter); }

	function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

	function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

	/**
	 * Use CompositeDecorator to build decoratorRanges with ranges, components, and props
	 */
	// This offsets or rather recalculates ranges for decorators
	// with punycode.ucs2.decode
	var offsetRanges = function offsetRanges(ranges, block) {
	  // if there are no decorator skip this step
	  ranges.forEach(function (range) {
	    var pre = block.text.substring(0, range.offset);
	    var decorated = block.text.substring(range.offset, range.offset + range.length); // eslint-disable-next-line no-param-reassign

	    range.offset = _punycode["default"].ucs2.decode(pre).length; // eslint-disable-next-line no-param-reassign

	    range.length = _punycode["default"].ucs2.decode(decorated).length;
	  });
	  return ranges;
	}; // Return true if decorator implements the DraftDecoratorType interface
	// @see https://github.com/facebook/draft-js/blob/master/src/model/decorators/DraftDecoratorType.js


	var decoratorIsCustom = function decoratorIsCustom(decorator) {
	  return typeof decorator.getDecorations === 'function' && typeof decorator.getComponentForKey === 'function' && typeof decorator.getPropsForKey === 'function';
	};

	var resolveDecorators = function resolveDecorators(decorators) {
	  var compositeDecorator = new _CompositeDecorator["default"](decorators.filter(function (decorator) {
	    return !decoratorIsCustom(decorator);
	  }));
	  var customDecorators = decorators.filter(function (decorator) {
	    return decoratorIsCustom(decorator);
	  });
	  var decor = [].concat(_toConsumableArray(customDecorators), [compositeDecorator]);
	  return new _MultiDecorator["default"](decor);
	};

	var decorateBlock = function decorateBlock(block, decorators, contentState, _ref) {
	  var createContentBlock = _ref.createContentBlock;
	  var decoratorRanges = []; // create a Decorator instance

	  var decorator = resolveDecorators(decorators); // create ContentBlock or a stub

	  var contentBlock = createContentBlock ? createContentBlock(block) : (0, _stubContentBlock["default"])(block); // Get decorations from CompositeDecorator instance

	  var decorations = decorator.getDecorations(contentBlock, contentState); // Keep track of offset for current key

	  var offset = 0;
	  decorations.forEach(function (key, index) {
	    // If no key just move the offset
	    if (!key) {
	      offset += 1;
	      return;
	    } // get next key


	    var nextIndex = index + 1;
	    var next = decorations[nextIndex]; // if thers no next key or the key chages build a decoratorRange entry

	    if (!next || next !== key) {
	      decoratorRanges.push({
	        offset: offset,
	        length: nextIndex - offset,
	        component: decorator.getComponentForKey(key),
	        decoratorProps: decorator.getPropsForKey(key) || {},
	        // save reference to contentState
	        contentState: contentState
	      }); // reset the offset to next index

	      offset = nextIndex;
	    }
	  }); // merge the block with decoratorRanges

	  return Object.assign({}, block, {
	    decoratorRanges: offsetRanges(decoratorRanges, block)
	  });
	};

	var withDecorators = function withDecorators(raw, decorators, options) {
	  var contentState = options.convertFromRaw && options.convertFromRaw(raw);
	  return raw.blocks.map(function (block) {
	    return decorateBlock(block, decorators, contentState, options || {});
	  });
	};

	var _default = withDecorators;
	exports["default"] = _default;
} (withDecorators));

Object.defineProperty(render$1, "__esModule", {
  value: true
});
render$1.render = render$1.renderNode = void 0;

var _RawParser = _interopRequireDefault(RawParser);

var _warn = _interopRequireDefault(warn);

var _checkCleanup = _interopRequireDefault(checkCleanup);

var _getKeyGenerator = _interopRequireDefault(getKeyGenerator);

var _checkJoin = _interopRequireDefault(checkJoin);

var _pushString = _interopRequireDefault(pushString);

var _defaultOptions = _interopRequireDefault(defaultOptions);

var _withDecorators = _interopRequireDefault(withDecorators);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var KEY_DELIMITER = '.';
var ATOMIC_BLOCK_TYPE = 'atomic';
/**
 * Recursively renders a node with nested nodes with given callbacks
 */

var renderNode = function renderNode(node, inlineRenderers, entityRenderers, styleRenderers, entityMap, options, keyGenerator) {
  if (node.styles && styleRenderers) {
    return styleRenderers((0, _checkJoin["default"])(node.content, options), node.styles, {
      key: keyGenerator()
    });
  }

  var children = [];
  var index = 0;
  node.content.forEach(function (part) {
    if (typeof part === 'string') {
      children = (0, _pushString["default"])(part, children, index);
    } else {
      index += 1;
      children[index] = renderNode(part, inlineRenderers, entityRenderers, styleRenderers, entityMap, options, keyGenerator);
      index += 1;
    }
  });

  if (node.style && inlineRenderers[node.style]) {
    return inlineRenderers[node.style]((0, _checkJoin["default"])(children, options), {
      key: keyGenerator()
    });
  }

  if (node.entity !== null) {
    var entity = entityMap[node.entity];
    var entityRenderer = entity && (entityRenderers[entity.type] || node.block.type === ATOMIC_BLOCK_TYPE && entityRenderers.atomicFallbackRenderer);

    if (entityRenderer) {
      return entityRenderer((0, _checkJoin["default"])(children, options), entity.data, {
        key: node.entity,
        block: node.block
      }, entity.type);
    }
  }

  if (node.decorator !== null) {
    // FIXME: few props are missing see https://github.com/facebook/draft-js/blob/0c609d9d3671fdbbe2a290ed160a0537f846f08e/src/component/contents/DraftEditorBlock.react.js#L196-L205
    var decoratorOffsetKey = [node.block.key, node.start, 0].join(KEY_DELIMITER);
    return node.decorator(Object.assign({
      children: (0, _checkJoin["default"])(children, options),
      decoratedText: node.decoratedText,
      contentState: node.contentState,
      entityKey: node.entity,
      offsetKey: decoratorOffsetKey,
      key: decoratorOffsetKey
    }, node.decoratorProps));
  }

  return children;
};
/**
 * Nests blocks by depth as children
 */


render$1.renderNode = renderNode;

var byDepth = function byDepth(blocks) {
  var group = [];
  var depthStack = [];
  var prevDepth = 0;

  var unwind = function unwind(targetDepth) {
    var i = prevDepth - targetDepth; // in case depthStack is too short for target depth

    if (depthStack.length < i) {
      i = depthStack.length;
    }

    for (i; i > 0; i -= 1) {
      var tmp = group;
      group = depthStack.pop();
      group[group.length - 1].children = tmp;
    }
  };

  blocks.forEach(function (block) {
    // if type of the block has changed render the block and clear group
    if (prevDepth < block.depth) {
      depthStack.push(group);
      group = [];
    } else if (prevDepth > block.depth) {
      unwind(block.depth);
    }

    prevDepth = block.depth;
    group.push(block);
  });

  if (prevDepth !== 0) {
    unwind(0);
  }

  return group;
};
/**
 * Conditionaly render a group if its not empty,
 * pass all the params to the renderers
 */


var renderGroup = function renderGroup(group, blockRenderers, rendered, params) {
  var type = params.prevType,
      depth = params.prevDepth,
      keys = params.prevKeys,
      data = params.prevData; // in case current group is empty it should not be rendered

  if (group.length === 0) {
    return;
  }

  if (blockRenderers[type]) {
    var props = {
      depth: depth,
      keys: keys
    };

    if (data && data.some(function (item) {
      return !!item;
    })) {
      props.data = data;
    }

    rendered.push(blockRenderers[type](group, props));
    return;
  }

  rendered.push(group);
};
/**
 * Renders blocks grouped by type using provided blockStyleRenderers
 */


var renderBlocks = function renderBlocks(blocks) {
  var inlineRenderers = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var blockRenderers = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var entityRenderers = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
  var stylesRenderer = arguments.length > 4 ? arguments[4] : undefined;
  var entityMap = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : {};
  var userOptions = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : {};
  // initialize
  var options = Object.assign({}, _defaultOptions["default"], userOptions);
  var rendered = [];
  var group = [];
  var prevType = null;
  var prevDepth = 0;
  var prevKeys = [];
  var prevData = [];
  var splitGroup = false;
  var Parser = new _RawParser["default"]({
    flat: !!stylesRenderer
  });
  blocks.forEach(function (block) {
    if ((0, _checkCleanup["default"])(block, prevType, options)) {
      // Set the split flag if enabled
      if (options.cleanup.split === true) {
        splitGroup = true;
      }

      return;
    }

    var node = Parser.parse(block);
    var renderedNode = renderNode(node, inlineRenderers, entityRenderers, stylesRenderer, entityMap, options, (0, _getKeyGenerator["default"])()); // if type of the block has changed or the split flag is set
    // render and clear group

    if (prevType && prevType !== block.type || splitGroup) {
      renderGroup(group, blockRenderers, rendered, {
        prevType: prevType,
        prevDepth: prevDepth,
        prevKeys: prevKeys,
        prevData: prevData
      }); // reset group vars
      // IDEA: might be worth to group those into an instance and just newup a new one

      prevData = [];
      prevKeys = [];
      group = [];
      splitGroup = false;
    } // handle children


    if (block.children) {
      var children = renderBlocks(block.children, inlineRenderers, blockRenderers, entityRenderers, stylesRenderer, entityMap, options);
      renderedNode.push(children);
    } // push current node to group


    group.push(renderedNode); // lastly save current type for refference

    prevType = block.type;
    prevDepth = block.depth;
    prevKeys.push(block.key);
    prevData.push(block.data);
  }); // render last group

  renderGroup(group, blockRenderers, rendered, {
    prevType: prevType,
    prevDepth: prevDepth,
    prevKeys: prevKeys,
    prevData: prevData
  });
  return (0, _checkJoin["default"])(rendered, options);
};
/**
 * Converts and renders each block of Draft.js rawState
 */


var render = function render(raw) {
  var renderers = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

  if (!raw || !Array.isArray(raw.blocks)) {
    (0, _warn["default"])('invalid raw object');
    return null;
  } // If the lenght of the blocks array is 0 its should not log a warning but still return a null


  if (!raw.blocks.length) {
    return null;
  }

  var inlineRenderers = renderers.inline,
      blockRenderers = renderers.blocks,
      entityRenderers = renderers.entities,
      stylesRenderer = renderers.styles,
      decorators = renderers.decorators; // If decorators are present, they are maped with the blocks array

  var blocksWithDecorators = decorators ? (0, _withDecorators["default"])(raw, decorators, options) : raw.blocks; // Nest blocks by depth

  var blocks = byDepth(blocksWithDecorators);
  return renderBlocks(blocks, inlineRenderers, blockRenderers, entityRenderers, stylesRenderer, raw.entityMap, options);
};

render$1.render = render;

(function (exports) {

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "RawParser", {
	  enumerable: true,
	  get: function get() {
	    return _RawParser["default"];
	  }
	});
	Object.defineProperty(exports, "createStylesRenderer", {
	  enumerable: true,
	  get: function get() {
	    return _createStyleRenderer["default"];
	  }
	});
	Object.defineProperty(exports, "createBlockRenderer", {
	  enumerable: true,
	  get: function get() {
	    return _createBlockRenderer["default"];
	  }
	});
	Object.defineProperty(exports, "renderNode", {
	  enumerable: true,
	  get: function get() {
	    return _render.renderNode;
	  }
	});
	Object.defineProperty(exports, "CompositeDecorator", {
	  enumerable: true,
	  get: function get() {
	    return _CompositeDecorator["default"];
	  }
	});
	exports["default"] = void 0;

	var _RawParser = _interopRequireDefault(RawParser);

	var _createStyleRenderer = _interopRequireDefault(createStyleRenderer);

	var _createBlockRenderer = _interopRequireDefault(createBlockRenderer);

	var _render = render$1;

	var _CompositeDecorator = _interopRequireDefault(CompositeDecorator);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

	var _default = _render.render;
	exports["default"] = _default;
} (lib));

var redraft = /*@__PURE__*/getDefaultExportFromCjs(lib);

var __defProp$2 = Object.defineProperty;
var __defProps$1 = Object.defineProperties;
var __getOwnPropDescs$1 = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols$2 = Object.getOwnPropertySymbols;
var __hasOwnProp$2 = Object.prototype.hasOwnProperty;
var __propIsEnum$2 = Object.prototype.propertyIsEnumerable;
var __defNormalProp$2 = (obj, key, value) => key in obj ? __defProp$2(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$2 = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$2.call(b, prop))
      __defNormalProp$2(a, prop, b[prop]);
  if (__getOwnPropSymbols$2)
    for (var prop of __getOwnPropSymbols$2(b)) {
      if (__propIsEnum$2.call(b, prop))
        __defNormalProp$2(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps$1 = (a, b) => __defProps$1(a, __getOwnPropDescs$1(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$2.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$2)
    for (var prop of __getOwnPropSymbols$2(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$2.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const isEmptyContentState = (raw) => !raw || !raw.blocks || raw.blocks.length === 1 && raw.blocks[0].text === "" && raw.blocks[0].type === "unstyled";
const isEmptyBlock = ([_, data]) => data && data.length === 0;
const getBlockStyleClasses = (mergedStyles, textDirection, textAlignment, classes, isListItem) => {
  const rtl = textDirection === "rtl";
  const defaultTextAlignment = rtl ? "right" : "left";
  const languageDirection = textDirection || "ltr";
  const alignmentClass = textAlignment || defaultTextAlignment;
  const directionRTL = isListItem ? rtl : languageDirection !== "ltr";
  const directionClass = directionRTL ? mergedStyles.rtl : mergedStyles.ltr;
  return classNames(classes, directionClass, mergedStyles[alignmentClass]);
};
const blockDataToStyle = ({ dynamicStyles }) => kebabToCamelObjectKeys(dynamicStyles);
const getInline = (contentState, config, inlineStyleMappers, mergedStyles) => combineMappers(
  [...inlineStyleMappers, ...getViewerInlineStyleMappers(contentState, config)],
  mergedStyles
);
const getBlocks = (mergedStyles, textDirection, context, addAnchorsPrefix, documentStyle) => {
  const getList = (ordered) => (items, blockProps) => {
    const fixedItems = items.map((item) => item.length ? item : [" "]);
    const props = {
      key: blockProps.keys[0],
      items: fixedItems,
      ordered,
      mergedStyles,
      textDirection,
      blockProps,
      getBlockStyleClasses,
      blockDataToStyle: ({ dynamicStyles }) => {
        return __spreadValues$2(__spreadValues$2({}, kebabToCamelObjectKeys(documentStyle == null ? void 0 : documentStyle[DOC_STYLE_TYPES.P])), blockDataToStyle({ dynamicStyles }));
      },
      context
    };
    return /* @__PURE__ */ React.createElement(List, __spreadValues$2({}, props));
  };
  const blockFactory = (type, style) => {
    return (children, blockProps) => children.map((child, i) => {
      var _a, _b, _c, _d;
      const alignment = ((_a = blockProps.data[i]) == null ? void 0 : _a.textAlignment) || context.textAlignment;
      const depth = blockProps.data[i].depth;
      const blockDirection = getDirectionFromAlignmentAndTextDirection(
        alignment,
        textDirection || ((_b = blockProps.data[i]) == null ? void 0 : _b.textDirection)
      );
      const hasJustifyText = alignment === "justify" && hasText(child);
      const directionBlockClassName = `public-DraftStyleDefault-text-${blockDirection}`;
      const directionTextClassName = `public-DraftStyleDefault-${textDirection || ((_c = blockProps.data[i]) == null ? void 0 : _c.textDirection) || "ltr"}`;
      const ChildTag = typeof type === "string" ? type : type(child);
      const blockIndex = blockProps.data[i].index;
      const { interactions } = blockProps.data[i];
      const _child = isEmptyBlock(child) ? /* @__PURE__ */ React.createElement("br", { role: "presentation" }) : child;
      const nodeStyle = documentStyle == null ? void 0 : documentStyle[style === "text" ? DOC_STYLE_TYPES.P : style];
      const parsedNodeStyle = kebabToCamelObjectKeys(nodeStyle);
      let content = _child;
      if (style === "text" || Object.values(DOC_STYLE_TYPES).includes(style)) {
        content = isEmpty(nodeStyle) ? /* @__PURE__ */ React.createElement("span", null, content) : /* @__PURE__ */ React.createElement("span", { className: nodeStyle.color && viewerStyles.overrideLinkColor, style: parsedNodeStyle }, content);
      }
      const inner = /* @__PURE__ */ React.createElement(React.Fragment, { key: blockProps.keys[i] }, /* @__PURE__ */ React.createElement(
        ChildTag,
        {
          id: `viewer-${blockProps.keys[i]}`,
          className: classNames(
            getBlockStyleClasses(
              mergedStyles,
              textDirection || ((_d = blockProps.data[i]) == null ? void 0 : _d.textDirection),
              alignment,
              mergedStyles[style]
            ),
            depthClassName(depth),
            "fixed-tab-size",
            directionBlockClassName,
            isPaywallSeo(context.seoMode) && getPaywallSeoClass(context.seoMode.paywall, blockIndex)
          ),
          style: blockDataToStyle(blockProps.data[i])
        },
        /* @__PURE__ */ React.createElement(
          "span",
          {
            className: classNames(
              viewerStyles.child,
              directionTextClassName,
              hasJustifyText && viewerStyles.hasJustifyText
            )
          },
          content
        )
      ));
      const wrappedBlock = withInteraction(inner, interactions, context);
      const wrapperKey = `${blockProps.keys[i]}_wrap`;
      let resultBlock = /* @__PURE__ */ React.createElement(React.Fragment, { key: wrapperKey }, wrappedBlock);
      const getAnchorType = () => {
        if (isEmptyBlock(child)) {
          return "empty-line";
        }
        return typeof type === "string" ? type : "paragraph";
      };
      if (addAnchorsPrefix) {
        const anchorKey = `${addAnchorsPrefix}${blockIndex + 1}`;
        resultBlock = /* @__PURE__ */ React.createElement(React.Fragment, { key: wrapperKey }, wrappedBlock, /* @__PURE__ */ React.createElement(Anchor, { type: getAnchorType(), key: anchorKey, anchorKey }));
      }
      return /* @__PURE__ */ React.createElement(ErrorBoundary, { key: `error-${wrapperKey}` }, resultBlock);
    });
  };
  return {
    unstyled: blockFactory((child) => isEmptyBlock(child) ? "div" : "p", "text"),
    blockquote: blockFactory("blockquote", "quote"),
    "header-one": blockFactory("h1", "headerOne"),
    "header-two": blockFactory("h2", "headerTwo"),
    "header-three": blockFactory("h3", "headerThree"),
    "header-four": blockFactory("h4", "headerFour"),
    "header-five": blockFactory("h5", "headerFive"),
    "header-six": blockFactory("h6", "headerSix"),
    "code-block": blockFactory("pre", "codeBlock"),
    "unordered-list-item": getList(false),
    "ordered-list-item": getList(true)
  };
};
const getEntities = (typeMappers, context, styles2, addAnchorsPrefix, innerRCEViewerProps, SpoilerViewerWrapper) => {
  const emojiViewerFn = (emojiUnicode, data, { key }) => {
    return /* @__PURE__ */ React.createElement("span", { key, style: { fontFamily: "cursive" } }, emojiUnicode);
  };
  return __spreadValues$2({
    EMOJI_TYPE: emojiViewerFn
  }, getPluginViewers(
    SpoilerViewerWrapper,
    typeMappers,
    context,
    styles2,
    addAnchorsPrefix,
    innerRCEViewerProps
  ));
};
const normalizeContentState = (contentState) => __spreadProps$1(__spreadValues$2({}, contentState), {
  blocks: contentState.blocks.map((block, index) => {
    if (block.type === "atomic") {
      return __spreadProps$1(__spreadValues$2({}, block), {
        data: { index }
      });
    }
    const textDirection = getTextDirection(block.text);
    const data = __spreadValues$2(__spreadProps$1(__spreadValues$2({}, block.data), {
      depth: block.depth,
      index
    }), textDirection === "rtl" && { textDirection });
    let text = block.text;
    if (endsWith(text, "\n")) {
      text += "\n";
    }
    return __spreadProps$1(__spreadValues$2({}, block), {
      depth: 0,
      data,
      text
    });
  })
});
const redraftOptions = {
  cleanup: {
    after: BLOCK_TYPES.filter((t) => t.indexOf("header") === -1),
    split: true,
    except: [
      "unordered-list-item",
      "ordered-list-item",
      "unstyled",
      "header-one",
      "header-two",
      "header-three",
      "header-four",
      "header-five",
      "header-six"
    ]
  },
  convertFromRaw: (contentState) => contentState
};
const convertToReact = (mergedStyles, textDirection, typeMappers, context, decorators, inlineStyleMappers, config, initSpoilers, SpoilerViewerWrapper, options = {}, innerRCEViewerProps, externalDocumentStyle) => {
  if (isEmptyContentState(context.contentState)) {
    return null;
  }
  const _a = options, { addAnchors } = _a, restOptions = __objRest(_a, ["addAnchors"]);
  const normalizedContentState = context.contentState ? normalizeContentState(context.contentState) : context.contentState;
  const newContentState = initSpoilers ? initSpoilers(normalizedContentState) : normalizedContentState;
  const addAnchorsPrefix = addAnchors && (addAnchors === true ? "rcv-block" : addAnchors);
  const documentStyle = externalDocumentStyle || (newContentState == null ? void 0 : newContentState.documentStyle);
  let result = redraft(
    newContentState,
    {
      inline: getInline(newContentState, config, inlineStyleMappers, mergedStyles),
      blocks: getBlocks(mergedStyles, textDirection, context, addAnchorsPrefix, documentStyle),
      entities: getEntities(
        typeMappers,
        context,
        mergedStyles,
        addAnchorsPrefix,
        __spreadProps$1(__spreadValues$2({}, innerRCEViewerProps), { documentStyle }),
        SpoilerViewerWrapper
      ),
      decorators
    },
    __spreadValues$2(__spreadValues$2({}, redraftOptions), restOptions)
  );
  if (addAnchors) {
    const firstAnchorKey = `${addAnchorsPrefix}-first`;
    const lastAnchorKey = `${addAnchorsPrefix}-last`;
    result = /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(Anchor, { type: "first", anchorKey: firstAnchorKey }), result, /* @__PURE__ */ React.createElement(Anchor, { type: "last", anchorKey: lastAnchorKey }));
  }
  return result;
};
const convertToHTML = (reactOutput, renderToStaticMarkup) => {
  if (!reactOutput) {
    return null;
  }
  return reactOutput.reduce((html, blocks) => {
    const blocksArr = blocks instanceof Array ? blocks : [blocks];
    blocksArr.forEach((c) => html += renderToStaticMarkup(c));
    return html;
  }, "");
};

var viewerAlignmentStyles = {"alignLeft":"-jC8z","textWrapNowrap":"h1LxM","alignRight":"jKKp9","alignCenter":"gO6aa","sizeFullWidth":"MM2xW","renderedInTable":"UMsJ3","sizeOriginal":"vEOuy","sizeContent":"flaqF","sizeSmall":"UAgbc","sizeSmallCenter":"I05bJ","flex":"AB5gP","left":"lnyWN","center":"cDpYU","right":"UETKq"};

var rtlStyle = {"rtl":"T1idq","ltr":"OZy-3"};

var __defProp$1 = Object.defineProperty;
var __getOwnPropSymbols$1 = Object.getOwnPropertySymbols;
var __hasOwnProp$1 = Object.prototype.hasOwnProperty;
var __propIsEnum$1 = Object.prototype.propertyIsEnumerable;
var __defNormalProp$1 = (obj, key, value) => key in obj ? __defProp$1(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$1 = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$1.call(b, prop))
      __defNormalProp$1(a, prop, b[prop]);
  if (__getOwnPropSymbols$1)
    for (var prop of __getOwnPropSymbols$1(b)) {
      if (__propIsEnum$1.call(b, prop))
        __defNormalProp$1(a, prop, b[prop]);
    }
  return a;
};
const _RichContentViewer = class extends Component {
  constructor(props) {
    var _a;
    super(props);
    this.getContextualData = ({
      t,
      theme,
      isMobile = false,
      anchorTarget,
      relValue,
      customAnchorScroll,
      config,
      helpers = {},
      locale,
      disabled,
      seoMode,
      iframeSandboxDomain,
      textAlignment,
      experiments
    }, contentState) => {
      var _a;
      deprecateHelpers(helpers, config);
      return {
        t,
        theme,
        isMobile,
        anchorTarget,
        relValue,
        customAnchorScroll,
        config,
        helpers,
        locale,
        disabled,
        seoMode,
        contentState,
        iframeSandboxDomain,
        disableRightClick: (_a = config == null ? void 0 : config.uiSettings) == null ? void 0 : _a.disableRightClick,
        textAlignment,
        experiments
      };
    };
    const { experiments = {}, isMobile = false, t } = props;
    const styles = __spreadValues$1(__spreadValues$1(__spreadValues$1({}, viewerStyles), viewerAlignmentStyles), rtlStyle);
    this.styles = ((_a = experiments == null ? void 0 : experiments.ricosViewerNext) == null ? void 0 : _a.enabled) ? styles : mergeStyles({ styles, theme: props.theme });
    this.typeMappers = combineMappers(props.typeMappers);
    this.state = {
      context: { experiments, isMobile, t }
    };
  }
  static getDerivedStateFromProps(props) {
    return {
      raw: _RichContentViewer.getInitialState(props)
    };
  }
  componentDidMount() {
    this.reportDebuggingInfo();
  }
  reportDebuggingInfo() {
    if (typeof window === "undefined") {
      return;
    }
    if (/ricos-debug/i.test(window.location.search) && !window.__RICOS_INFO__) {
      import(
        /* webpackChunkName: "debugging-info" */
        'wix-rich-content-common/libs/debugging-info'
      ).then(({ reportDebuggingInfo }) => {
        reportDebuggingInfo({
          version: Version.currentVersion,
          reporter: "Rich Content Viewer",
          plugins: Object.keys(this.typeMappers),
          getContent: () => this.props.initialState,
          getConfig: () => this.props.config
        });
      });
    }
  }
  render() {
    var _a, _b;
    const {
      config = {},
      onHover,
      isMobile,
      isInnerRcv,
      textDirection,
      direction,
      inlineStyleMappers,
      locale,
      addAnchors,
      renderedInTable,
      platform,
      t,
      typeMappers,
      setRef = () => {
      },
      onMouseOver = () => {
      },
      experiments = {}
    } = this.props;
    const decorators = [...this.props.decorators, createJustificationFixDecorator()];
    const { styles } = this;
    const wrapperClassName = classNames(styles.wrapper, {
      [styles.desktop]: !platform || platform === "desktop"
    });
    const tableClassNames = classNames(
      styles.renderedInTable,
      viewerStyles.renderedInTable,
      draftDefaultStyles.renderedInTable
    );
    const editorClassName = classNames(styles.editor, renderedInTable && tableClassNames, {
      [styles.rtl]: textDirection === "rtl"
    });
    const initSpoilers = (_a = config[SPOILER_TYPE]) == null ? void 0 : _a.initSpoilersContentState;
    const SpoilerViewerWrapper = (_b = config[SPOILER_TYPE]) == null ? void 0 : _b.SpoilerViewerWrapper;
    const contextualData = this.getContextualData(this.props, this.state.raw);
    const innerRCEViewerProps = {
      typeMappers,
      inlineStyleMappers,
      decorators,
      config,
      t,
      renderedInTable,
      isMobile
    };
    const output = convertToReact(
      styles,
      textDirection,
      this.typeMappers,
      contextualData,
      decorators,
      inlineStyleMappers,
      config,
      initSpoilers,
      SpoilerViewerWrapper,
      { addAnchors },
      innerRCEViewerProps,
      this.props.documentStyle
    );
    const dataId = isInnerRcv ? {} : { "data-id": "rich-content-viewer" };
    return /* @__PURE__ */ React.createElement(GlobalContext.Provider, { value: this.state.context }, /* @__PURE__ */ React.createElement(
      "div",
      __spreadValues$1({
        className: wrapperClassName,
        dir: direction || getLangDir(locale),
        onMouseEnter: (e) => onHover && onHover(e),
        ref: setRef,
        onMouseOver
      }, dataId),
      /* @__PURE__ */ React.createElement("div", { className: editorClassName, "data-query": "media" }, output),
      /* @__PURE__ */ React.createElement(AccessibilityListener, { isMobile })
    ));
  }
};
let RichContentViewer = _RichContentViewer;
RichContentViewer.defaultProps = {
  theme: {},
  decorators: [],
  typeMappers: [],
  inlineStyleMappers: [],
  locale: "en",
  normalize: {},
  config: {}
};
RichContentViewer.getInitialState = (props) => {
  var _a, _b, _c;
  const {
    initialState,
    anchorTarget,
    relValue,
    normalize: { disableInlineImages = false, removeInvalidInlinePlugins = false },
    config
  } = props;
  const { uiSettings } = config;
  const disableImagesExpand = (_a = config[IMAGE_TYPE]) == null ? void 0 : _a.disableExpand;
  const disableGalleryExpand = (_b = config[GALLERY_TYPE]) == null ? void 0 : _b.disableExpand;
  const disableDownload = ((_c = config[VIDEO_TYPE]) == null ? void 0 : _c.disableDownload) || (uiSettings == null ? void 0 : uiSettings.disableRightClick) || (uiSettings == null ? void 0 : uiSettings.disableDownload);
  return initialState ? normalizeInitialState(initialState, {
    anchorTarget,
    relValue,
    disableInlineImages,
    removeInvalidInlinePlugins,
    disableDownload,
    disableImagesExpand,
    disableGalleryExpand
  }) : void 0;
};

var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __publicField = (obj, key, value) => {
  __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};
class PluginViewer extends PureComponent {
  constructor() {
    super(...arguments);
    __publicField(this, "getContainerClassNames", () => {
      const {
        pluginComponent,
        componentData,
        styles,
        context: { theme, isMobile },
        type
      } = this.props;
      const { size, alignment, textWrap, custom } = pluginComponent.classNameStrategies || {};
      const hasLink = this.componentHasLink();
      const { html } = componentData;
      return classNames(
        styles.pluginContainerReadOnly,
        {
          [styles.pluginContainerMobile]: isMobile,
          [styles.anchor]: hasLink,
          [theme.anchor]: hasLink && theme.anchor,
          [styles.embed]: hasLink && html,
          [styles.horizontalScrollbar]: pluginComponent.withHorizontalScroll
        },
        isFunction(alignment) ? alignment(componentData, theme, styles, isMobile) : alignmentClassName(componentData, theme, styles, isMobile),
        isFunction(size) ? size(componentData, theme, styles, isMobile) : sizeClassName(componentData, theme, styles, isMobile),
        isFunction(textWrap) ? textWrap(componentData, theme, styles, isMobile) : textWrapClassName(componentData, theme, styles, isMobile),
        isFunction(custom) ? custom(componentData, theme, styles, isMobile) : null
      );
    });
    __publicField(this, "componentHasLink", () => {
      var _a, _b, _c, _d;
      return (_d = (_c = (_b = (_a = this.props) == null ? void 0 : _a.componentData) == null ? void 0 : _b.config) == null ? void 0 : _c.link) == null ? void 0 : _d.url;
    });
    __publicField(this, "componentHasAnchor", () => {
      var _a, _b, _c, _d;
      return (_d = (_c = (_b = (_a = this.props) == null ? void 0 : _a.componentData) == null ? void 0 : _b.config) == null ? void 0 : _c.link) == null ? void 0 : _d.anchor;
    });
    __publicField(this, "innerRCV", ({ contentState, textAlignment, direction, renderedIn }) => {
      const { innerRCEViewerProps } = this.props;
      const renderedInTable = renderedIn === TABLE_TYPE;
      return /* @__PURE__ */ React.createElement(
        RichContentViewer,
        __spreadProps(__spreadValues({
          initialState: contentState,
          textAlignment,
          direction
        }, innerRCEViewerProps), {
          isInnerRcv: true,
          renderedInTable
        })
      );
    });
  }
  /* eslint-disable complexity */
  render() {
    var _a;
    const {
      id,
      type,
      pluginComponent,
      componentData,
      children,
      styles,
      entityIndex,
      context,
      blockIndex,
      SpoilerViewerWrapper,
      blockKey
    } = this.props;
    const { component: Component, elementType } = pluginComponent;
    const { container } = pluginComponent.classNameStrategies || {};
    const { anchorTarget, config, theme, isMobile } = context;
    const settings = (config == null ? void 0 : config[type]) || {};
    const componentProps = __spreadProps(__spreadValues({
      type,
      componentData,
      settings,
      children,
      entityIndex
    }, context), {
      innerRCV: this.innerRCV,
      blockKey
    });
    if (Component) {
      if (elementType !== "inline") {
        const { config: config2 = {} } = componentData;
        const hasLink = this.componentHasLink();
        const hasAnchor = this.componentHasAnchor();
        const ContainerElement = hasLink || hasAnchor ? "a" : "div";
        let containerProps = {};
        if (hasLink) {
          const { url, target = anchorTarget, rel } = config2.link;
          containerProps = {
            href: normalizeHref(url),
            target,
            rel: getRelValue(rel)
          };
        }
        if (hasAnchor) {
          const { anchor } = config2.link;
          const href = `#viewer-${anchor}`;
          containerProps = {
            href,
            target: "_self"
          };
        }
        let customStyles;
        if (config2.size === "inline" || type === HTML_TYPE || type === MAP_TYPE) {
          customStyles = { width: config2.width };
        }
        if (type === IMAGE_TYPE) {
          const { src = {} } = componentData;
          const { size } = config2;
          if (src.width && (size === "original" || isMobile && size === "inline" && config2.width && config2.width > 150)) {
            customStyles = { width: src.width, maxWidth: "100%" };
          }
        }
        if ((type === ACTION_BUTTON_TYPE || type === LINK_BUTTON_TYPE) && isNumber(config2.width)) {
          componentProps.style = { width: config2.width };
        }
        if (customStyles) {
          containerProps.style = customStyles;
        }
        const ContainerClassName = this.getContainerClassNames();
        const ContainerComponent = /* @__PURE__ */ React.createElement(ContainerElement, __spreadValues({ className: ContainerClassName }, containerProps), isFunction(container) ? /* @__PURE__ */ React.createElement("div", { className: container(theme) }, /* @__PURE__ */ React.createElement(Component, __spreadValues({}, componentProps))) : /* @__PURE__ */ React.createElement(Component, __spreadValues({}, componentProps)));
        return /* @__PURE__ */ React.createElement(
          "div",
          {
            id,
            className: classNames(
              styles.atomic,
              isPaywallSeo(context.seoMode) && getPaywallSeoClass(context.seoMode.paywall, blockIndex)
            )
          },
          SpoilerViewerWrapper ? /* @__PURE__ */ React.createElement(
            SpoilerViewerWrapper,
            __spreadProps(__spreadValues({}, componentProps), {
              className: ContainerClassName,
              width: (_a = containerProps == null ? void 0 : containerProps.style) == null ? void 0 : _a.width
            }),
            ContainerComponent
          ) : ContainerComponent
        );
      } else {
        return SpoilerViewerWrapper ? /* @__PURE__ */ React.createElement(SpoilerViewerWrapper, __spreadValues({}, componentProps), /* @__PURE__ */ React.createElement(Component, __spreadValues({}, componentProps))) : /* @__PURE__ */ React.createElement(Component, __spreadValues({}, componentProps));
      }
    }
    return null;
  }
  /* eslint-enable complexity */
}
PluginViewer.propTypes = {
  SpoilerViewerWrapper: PropTypes.func,
  id: PropTypes.string.isRequired,
  type: PropTypes.string.isRequired,
  componentData: PropTypes.object.isRequired,
  pluginComponent: PropTypes.object.isRequired,
  entityIndex: PropTypes.number.isRequired,
  children: PropTypes.node,
  styles: PropTypes.object,
  context: PropTypes.shape({
    theme: PropTypes.object.isRequired,
    anchorTarget: PropTypes.string.isRequired,
    config: PropTypes.object.isRequired,
    isMobile: PropTypes.bool.isRequired,
    helpers: PropTypes.object.isRequired,
    t: PropTypes.func.isRequired,
    locale: PropTypes.string.isRequired,
    disabled: PropTypes.bool,
    seoMode: PropTypes.bool,
    iframeSandboxDomain: PropTypes.string,
    disableRightClick: PropTypes.bool
  }).isRequired,
  innerRCEViewerProps: PropTypes.object,
  blockIndex: PropTypes.number,
  blockKey: PropTypes.string
};
PluginViewer.defaultProps = {
  styles: {}
};
const getPluginViewers = (SpoilerViewerWrapper, typeMappers, context, styles, addAnchorsPrefix, innerRCEViewerProps) => {
  const res = {};
  Object.keys(typeMappers).forEach((type, i) => {
    res[type] = (children, entity, { key, block }) => {
      const pluginComponent = typeMappers[type];
      const isInline = pluginComponent.elementType === "inline";
      const { interactions } = entity;
      const pluginViewer = /* @__PURE__ */ React.createElement(
        PluginViewer,
        {
          id: `viewer-${block.key}`,
          type,
          pluginComponent,
          componentData: entity,
          entityIndex: key,
          context,
          styles,
          blockIndex: getBlockIndex(context.contentState, block.key),
          typeMap: typeMappers,
          innerRCEViewerProps,
          SpoilerViewerWrapper,
          withHorizontalScroll: true,
          blockKey: block.key
        },
        isInline ? children : null
      );
      const wrappedPluginViewer = withInteraction(pluginViewer, interactions, context);
      let anchorElement;
      if (addAnchorsPrefix && !isInline) {
        const anchorType = type.replace("wix-draft-plugin-", "").toLowerCase();
        const anchorKey = `${addAnchorsPrefix}${block.data.index + 1}`;
        anchorElement = /* @__PURE__ */ React.createElement(Anchor, { type: anchorType, anchorKey });
      }
      return /* @__PURE__ */ React.createElement(ErrorBoundary, { key: `${i}_${key}` }, wrappedPluginViewer, anchorElement);
    };
  });
  return res;
};

export { RichContentViewer as R, convertToHTML as a, convertToReact as c, getPluginViewers as g };
//# sourceMappingURL=getPluginViewers-4c08ec0d.js.map
